import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import History from '@/js/plugins/CookieDb/History';
import { authCheck, zeroPadding, isPc } from '@/js/helpers';
import Favorite from '@/js/plugins/CookieDb/Favorite';
import SmoothScroll from 'smooth-scroll';
import GalleryModal from '@/js/plugins/GalleryModal';
import Modal from '@/js/plugins/Modal';
import { Viewer } from '@photo-sphere-viewer/core';
import "@photo-sphere-viewer/core/index.css";

// サムネイルのもっと見る表示制御
const renderThumbnailAction = () => {
    let showAll = false;
    const thumbnailLength = $('.pg-gallery-thumbnails__item').not('[data-more]').length;
    if (isPc()) {
        if (thumbnailLength > 8) {
            showAll = true;
        }
    } else {
        if (thumbnailLength > 10) {
            showAll = true;
        }
    }
    if (showAll) {
        $('.pg-gallery-thumbnails__item[data-more]').on('click', (e) => {
            $('.pg-gallery-thumbnails__list').attr('data-render-no-limit', '');
        });
    }
}

// 画像のロード完了を待つ
const initImagesLoad = async (selector) => {
    const slider = document.querySelector(selector);
    const images = Array.from(slider.querySelectorAll('img'));

    // 画像ロードを Promise でラップ
    const loadPromises = images.map(img => {
        return new Promise(resolve => {
            if (img.complete) {
                resolve(); // すでにロード済み
            } else {
                img.addEventListener('load', resolve);
                img.addEventListener('error', resolve); // 失敗でも解決して次へ
            }
        });
    });

    return await Promise.all(loadPromises);
}

// 表示中の画像に対応するサムネイルにアクティブ状態(青枠)を付与し、
// サムネイルスライダーが見える範囲外にある場合はそこまでスクロールさせる
const setActiveGalleryThumbnail = (index) => {
    const items = document.querySelectorAll('.pg-gallery-thumbnails__item');
    items.forEach((item) => delete item.dataset.active);
    if (items[index]) {
        items[index].dataset.active = '';
    }

    const $thumbList = $('.js-gallery-thumbnails-slider');
    if ($thumbList.length === 0 || !$thumbList.hasClass('slick-initialized')) return;

    const slick = $thumbList.slick('getSlick');
    const { currentSlide, slideCount, options } = slick;
    const slidesToShow = options.slidesToShow;
    const isVisible = index >= currentSlide && index < currentSlide + slidesToShow;
    if (isVisible) return;

    const maxSlide = Math.max(slideCount - slidesToShow, 0);
    $thumbList.slick('slickGoTo', Math.min(Math.max(index, 0), maxSlide));
}

// ギャラリーのアクション設定
const setGalleryAction = async () => {
    renderThumbnailAction()
    let slideAllCount = 0;

    await initImagesLoad('.js-gallery-slider')
    .then(() => {
        const $slider = $(".js-gallery-slider");
        const slideCount = $slider.find('.slick-slide').length || $slider.children().length;

        // 1枚の場合は初期化しない
        if (slideCount <= 1) {
            $('.pg-gallery__pagination').text(`1 / 1`);
            return;
        }

        // スライダーアクション
        $slider.on('init', (event, slick) => {
            slideAllCount = slick.slideCount;
            $('.pg-gallery__pagination').text(`1 / ${slideAllCount}`);
            setActiveGalleryThumbnail(0);
        })
        .slick({
            fade: true,
            slidesToShow: 1,
            autoplay: true,
            // クリック直後の反映がもたつかないよう、フェード時間を短めにする
            speed: 300,
            autoplaySpeed: 5000,
            infinite: true,
            arrows: false,
            // trueのままだとフェード中(speed:300ms)に別のサムネイルをクリックしても
            // 弾かれてしまうため、常に最新のクリックを反映できるようにする
            waitForAnimate: false,
        })
        .on('afterChange', (event, slick, currentSlide) => {
            $('.pg-gallery__pagination').text(`${currentSlide + 1} / ${slideAllCount}`);
            setActiveGalleryThumbnail(currentSlide);
        });

        // カスタムナビゲーション
        const prevBtn = document.querySelector('.pg-gallery__nav-prev');
        const nextBtn = document.querySelector('.pg-gallery__nav-next');
        if (prevBtn) {
            prevBtn.addEventListener('click', () => $slider.slick('slickPrev'));
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', () => $slider.slick('slickNext'));
        }
    });
}

// サムネイル一覧を1列スライダー化し、左右の矢印ボタンで送れるようにする
const initGalleryThumbnailsSlider = async () => {
    const $list = $('.js-gallery-thumbnails-slider');
    if ($list.length === 0) return;

    const itemCount = $list.children('.pg-gallery-thumbnails__item').length;
    if (itemCount <= 1) return;

    // 画像ロード完了前にslickを初期化すると、レイアウト未確定のまま幅を計算してしまうため
    // メインスライダー同様、ロード完了を待ってから初期化する
    await initImagesLoad('.js-gallery-thumbnails-slider');

    // itemCountに合わせてslidesToShowを縮めると、画像が少ない時に1枚あたりの幅が
    // 間延びして大きくなってしまうため、表示枚数は固定し、足りない分は空きスペースにする
    // PCは矢印ボタンが最後尾のサムネイルに重ならないよう7枚ではなく6枚表示にする
    const slidesToShow = isPc() ? 6 : 4;
    const $wrapper = $list.closest('.pg-gallery-thumbnails__slider-wrapper');
    const $prevBtn = $wrapper.find('.pg-gallery-thumbnails__nav-prev');
    const $nextBtn = $wrapper.find('.pg-gallery-thumbnails__nav-next');

    // 先頭/末尾ではそれぞれの矢印を隠す
    const updateNav = (slick, currentSlide = slick.currentSlide) => {
        $prevBtn.toggle(currentSlide > 0);
        $nextBtn.toggle(currentSlide + slidesToShow < slick.slideCount);
    };

    $list
        .on('init', (event, slick) => updateNav(slick))
        .on('afterChange', (event, slick, currentSlide) => updateNav(slick, currentSlide))
        .slick({
            slidesToShow,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            // 矢印の連続クリックがアニメーション中に弾かれないようにする
            waitForAnimate: false,
        });

    // 現在アクティブ(青枠)なサムネイルのindexを取得
    const getActiveThumbnailIndex = () => {
        const items = document.querySelectorAll('.pg-gallery-thumbnails__item');
        const activeIndex = Array.from(items).findIndex((item) => item.dataset.active !== undefined);
        return activeIndex === -1 ? 0 : activeIndex;
    };

    // 矢印クリック時、アクティブな画像を前後に切り替える
    // (サムネイルのスクロール自体はsetActiveGalleryThumbnailが表示範囲外の時のみ行う)
    const goToAdjacentSlide = (diff) => {
        const nextIndex = Math.min(Math.max(getActiveThumbnailIndex() + diff, 0), itemCount - 1);
        setActiveGalleryThumbnail(nextIndex);
        $('.js-gallery-slider').slick('slickGoTo', nextIndex);
    };

    $prevBtn.on('click', () => goToAdjacentSlide(-1));
    $nextBtn.on('click', () => goToAdjacentSlide(1));
}

// スライドのページ切り替え
// サムネイルをslick化した際、各<li>はslickが生成するラッパーdivの唯一の子要素になり
// $(e.currentTarget).index()は常に0を返してしまうため、data-slick-indexから実際の位置を取得する
$('.pg-gallery-thumbnails__item').not('[data-more]').on('click', (e) => {
    const $item = $(e.currentTarget);
    const slickIndex = $item.closest('.slick-slide').data('slickIndex');
    const index = slickIndex !== undefined ? slickIndex : $item.index();
    // afterChangeの発火(スライド切り替えアニメーション完了後)を待たず、クリック直後に反映する
    setActiveGalleryThumbnail(index);
    $(".js-gallery-slider").slick('slickGoTo', index)
})

// 物件詳細の追加表示（SP）
// LP物件のように土地/戸建で.pg-estate-detail__groupが2つある場合は、
// クリックされたボタンが属するgroupだけを展開する。groupが無い通常物件では
// section自体(.pg-estate-detail)を展開する
const showPropertyDetail = () => {
    $('.pg-estate-detail__more a').on('click', (e) => {
        $(e.currentTarget).closest('.pg-estate-detail__group, .pg-estate-detail').addClass('is-open');
    })
}

const setFavoriteAction = async (pageId) => {
    const targetObjs = document.querySelectorAll('[data-type="favorite"]');
    const favorite = new Favorite();
    const targetDb = authCheck() ? 'db' : 'cookie';
    const changeFavoriteState = (target, newState) => {
        if (newState) {
            target.dataset.active = '';
        } else {
            delete target.dataset.active;
        }
        document.querySelectorAll('[data-favorite-count]').forEach((targetObj) => {
            const baseCount = targetObj.dataset.count ? Number(targetObj.dataset.count) : 0;
            const count = newState ? baseCount + 1 : baseCount - 1;
            targetObj.textContent = count < 99 ? count : '99+';
            targetObj.dataset.count = count;
        });
        document.querySelectorAll(`[data-type="favorite"][data-id="${pageId}"], .c-buttons-favorite[data-id="${pageId}"]`).forEach((targetObj) => {
            if (newState) {
                targetObj.dataset.active = '';
            }
            else {
                delete targetObj.dataset.active;
            }
        });
    }

    targetObjs.forEach((obj) => {
        obj.addEventListener('click', async (e) => {
            const isFavorite = e.currentTarget.hasAttribute('data-active');
            changeFavoriteState(e.currentTarget, !isFavorite);

            const resp = await favorite.setState(targetDb, pageId, !isFavorite)
            if (!resp) {
                changeFavoriteState(e.currentTarget, isFavorite);
            }
        })
    })
}

const setOpenHouseAction = () => {
    if (document.querySelector('.pg-tour-body') === null) return;
    document.querySelector('.pg-tour-body__more').addEventListener('click', (e) => {
        document.querySelector('.pg-tour__body').dataset.open = '';
    });
    // コンテンツの縦サイズが親の高さを超えていたら「もっと見る」ボタンを表示
    const tourBody = document.querySelector('.pg-tour__body');
    console.log(tourBody.scrollHeight, tourBody.clientHeight)
    if (tourBody.scrollHeight > tourBody.clientHeight) {
        document.querySelector('.pg-tour__body').dataset.more = '';
    }
}

const setOpenHouseBodyAction = () => {
    const openHouseBody = document.querySelector('.pg-open-house__body');
    if (openHouseBody === null) return;
    // コンテンツの縦サイズがmax-heightを超えていたら「もっと見る」ボタンを表示
    if (openHouseBody.scrollHeight > openHouseBody.clientHeight) {
        openHouseBody.dataset.more = '';
    }
    document.querySelector('.pg-open-house-body__more').addEventListener('click', () => {
        openHouseBody.dataset.open = '';
        delete openHouseBody.dataset.more;
    });
}

// 横スクロールスライダーを初期化する（1アイテムずつ矢印で移動）。
// ネイティブの overflow スクロールを使うことで、最後の画像がスクロール領域の右端で自然に停止する。
// 周辺環境(pg-amenities)・区画図(pg-land-parcel)など、同じ挙動のスライダー複数箇所で共用する
const initHorizontalSlider = (trackSelector, itemSelector, wrapperSelector, prevSelector, nextSelector) => {
    const track = document.querySelector(trackSelector);
    if (track === null) return;
    const items = track.querySelectorAll(itemSelector);
    // 1件以下ならスクロール不要
    if (items.length <= 1) return;

    const wrapper = track.closest(wrapperSelector) || track.parentElement;
    const prevBtn = wrapper.querySelector(prevSelector);
    const nextBtn = wrapper.querySelector(nextSelector);

    // 1スライド分のスクロール量（アイテム幅 + gap）。実DOMの位置差から算出する
    const getStep = () => {
        if (items.length >= 2) {
            const step = items[1].offsetLeft - items[0].offsetLeft;
            if (step > 0) return step;
        }
        return items[0].offsetWidth;
    };

    // 先頭/末尾でそれぞれの矢印を非表示にする
    const updateNav = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (prevBtn) {
            prevBtn.style.display = track.scrollLeft <= 1 ? 'none' : '';
        }
        if (nextBtn) {
            // 右端に到達したら next を隠す（1px許容）
            nextBtn.style.display = track.scrollLeft >= maxScroll - 1 ? 'none' : '';
        }
    };

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);

    updateNav();
}

const initAmenitiesSlider = () => {
    initHorizontalSlider(
        '.js-amenities-slider',
        '.pg-amenities-thumbnails__item',
        '.pg-amenities-slider',
        '.pg-amenities-slider__nav--prev',
        '.pg-amenities-slider__nav--next',
    );
}

// 区画図(画像区分ID1)の横スクロール化
const initLandParcelSlider = () => {
    initHorizontalSlider(
        '.js-land-parcel-slider',
        '.pg-land-parcel__item',
        '.pg-land-parcel__map',
        '.pg-land-parcel__nav--prev',
        '.pg-land-parcel__nav--next',
    );
}

const setAmenitiesAction = () => {
    // サムネイルスライダー初期化
    initAmenitiesSlider();

    const more = document.querySelector('button.pg-amenities__more');
    if (more === null) return;
    more.addEventListener('click', () => {
        document.querySelectorAll('.pg-amenities-group[data-more-content]').forEach((group) => {
            group.removeAttribute('hidden');
        });
        more.remove();
    });
}

const setHouseListAction = () => {
    const section = document.querySelector('.pg-house-list');
    if (section === null) return;

    const track = section.querySelector('.pg-house-list__cards');
    const cards = Array.from(section.querySelectorAll('.pg-house-list__card'));
    const tabs = Array.from(section.querySelectorAll('.pg-house-list-tab'));
    const scrollbar = section.querySelector('.pg-house-list__scrollbar');
    const thumb = section.querySelector('.pg-house-list__scrollbar-thumb');
    if (!track || !scrollbar || !thumb || cards.length === 0) return;

    const updateThumb = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const ratio = Math.min(track.clientWidth / track.scrollWidth, 1);
        const thumbWidth = scrollbar.clientWidth * ratio;
        const scrollRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        const maxThumbLeft = scrollbar.clientWidth - thumbWidth;

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${scrollRatio * maxThumbLeft}px)`;
    };

    const updateEndPadding = () => {
        const lastCard = cards[cards.length - 1];
        if (!lastCard) return;

        const trackStyle = window.getComputedStyle(track);
        const paddingLeft = parseFloat(trackStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(trackStyle.paddingRight) || 0;
        const requiredPaddingRight = Math.max(track.clientWidth - paddingLeft - lastCard.offsetWidth, paddingRight);

        track.style.paddingRight = `${requiredPaddingRight}px`;
    };

    const getCardScrollLeft = (card) => {
        const trackRect = track.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const paddingLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const left = track.scrollLeft + cardRect.left - trackRect.left - paddingLeft;

        return Math.max(0, Math.min(left, maxScroll));
    };

    // タブクリックで該当カードへスクロール。
    // アクティブ表示はマウスオーバー時のみ（CSSの :hover で制御）で、スクロール連動での自動切替は行わない。
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            const card = cards.find((card) => card.dataset.building === tab.dataset.building) || cards[index];
            if (!card) return;
            updateEndPadding();
            track.scrollTo({ left: getCardScrollLeft(card), behavior: 'smooth' });
        });
    });

    track.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', () => {
        track.style.paddingRight = '';
        updateEndPadding();
        updateThumb();
    });

    updateEndPadding();
    updateThumb();
}

const setPointTextAction = () => {
    const pointText = document.querySelector('.pg-point-text');
    if (pointText === null) return;
    // 省略の対象は説明文のみ（キャッチコピーは常に全文表示）
    const explanation = pointText.querySelector('.pg-point-text__explanation');
    const more = pointText.querySelector('.pg-point-text__more');
    if (!explanation || !more) return;

    // 説明文がクランプした高さを超えていたら「もっと見る」ボタンを表示
    // ※1px程度の誤差で誤検知しないよう余裕を持たせる
    const updateMore = () => {
        // 展開済みのときは判定しない（クランプが解除され常に超過しなくなるため）
        if (pointText.hasAttribute('data-open')) return;
        pointText.toggleAttribute('data-more', explanation.scrollHeight > explanation.clientHeight + 1);
    };

    updateMore();
    // Webフォント読み込みで行数が変わるため、確定後に再判定する
    document.fonts?.ready.then(updateMore);
    window.addEventListener('resize', updateMore);

    more.addEventListener('click', () => {
        pointText.dataset.open = '';
        delete pointText.dataset.more;
    });
}

// 360度画像の表示
export const set360Image = () => {
    if(!document.querySelector('.pg-panorama')) return;
    const firstItem = document.querySelector('.pg-panorama__item');
    const viewer = new Viewer({
        container: document.querySelector('.pg-panorama__viewer'),
        panorama: firstItem.dataset.url || '',
        defaultZoomLvl: 0, // いちばんズームアウト
    });

    document.querySelectorAll('.pg-panorama__item').forEach(item => {
        item.addEventListener('click', (e) => {
            const url = e.currentTarget.dataset.url;
            viewer.setPanorama(url);

            // クリックされたアイテムをアクティブにする
            document.querySelectorAll('.pg-panorama__item').forEach(el => {
                delete el.dataset.active;
            });
            e.currentTarget.dataset.active = '';
        });
    });
    document.querySelector('.pg-panorama__item').dataset.active = '';
}


// SmoothScroll の header オプションは getHeight(header) + header.offsetTop で高さを算出するが、
// .l-header は position: sticky のため、スティック中の offsetTop は「現在のスクロール量」を返してしまい
// （固定要素のような常に0の値にならない）、スクロールするほど誤差が拡大して着地位置がずれるバグの原因になっていた。
// そのため header オプションは使わず、追従要素の高さをここで直接合算する。
//
// SPでは .l-header と .pg-nav の間に .l-header__area-bar が常時表示で挟まる
// （detail.scss: .pg-nav の top も calc(50px + var(--area-bar-height)) で同じ分オフセットしている）。
// これを合算し忘れるとバーの高さぶん着地位置が上にずれ、遷移先の見出しが追従要素の下に隠れる。
// PCでは display:none のため getBoundingClientRect().height が 0 になり、自動的に加算されない。
// @include md の閾値（components/others/_area-bar-scroll.js と同じ値）
const BP_MD = 768;

// PCのみ、追従要素の直下ぴったりではなく余白を空けて着地させる。
// SPは画面が狭く、余白を足すと遷移先の内容が見える範囲がそのぶん削られるため加算しない
const LANDING_GAP_PC = 40;

const getNavScrollOffset = () => {
    const measure = (selector) => document.querySelector(selector)?.getBoundingClientRect().height || 0;
    const isPc = !window.matchMedia(`(max-width: ${BP_MD}px)`).matches;

    return (
        measure('.l-header') +
        measure('.l-header__area-bar') +
        measure('.pg-nav') +
        (isPc ? LANDING_GAP_PC : 0)
    );
};

// scroll-margin-top を SmoothScroll のオフセットと同期させておく
// （:target 遷移など、JS のスクロール制御を経由しないケースの保険）
const applyScrollMarginOffset = () => {
    document.documentElement.style.setProperty('--nav-scroll-offset', `${getNavScrollOffset()}px`);
};

// ページ内リンク（href="#xxx"）がクリックされてから、実際にスクロールが止まるまでを
// 検知する仕組み。SmoothScroll ライブラリ自身が発火する scrollStart/scrollStop イベントには
// 依存しない。
//
// 理由: ライブラリ内部の prefers-reduced-motion 判定に既知のバグがあり
// （`matchMedia('(prefers-reduced-motion)')` を値なしで判定しており、環境によって
// 「reduce を希望していない」ケースでも true 扱いになることがある）、環境によっては
// アニメーションを行わない「瞬間ジャンプ」の分岐に入り、scrollStart/scrollStop が
// 一度も発火しない。この場合、
//   - 遷移先へのネイティブ focus() によるスクロールが巻き添えで発生する
//   - html の scroll-behavior: smooth がそのまま残り、ネイティブスムーズスクロールと
//     二重に干渉する
// ため、着地位置がブレたり、ナビの下線が一瞬別項目になってからすぐ戻る、といった
// 症状が起きていた（アニメーションする通常経路では気づきにくい）。
//
// クリックそのものと、その後の 'scroll' イベントが一定時間止まったこと（＝着地）を
// 直接監視することで、ライブラリがどちらの内部経路を通っても同じように動作する。
const observeAnchorNavigation = (onSettle) => {
    const root = document.documentElement;
    const nativeFocus = Element.prototype.focus;
    const SETTLE_DELAY = 150;
    let settleTimer = null;
    let navigating = false;
    let currentTarget = null;

    const finish = () => {
        navigating = false;
        root.style.scrollBehavior = '';
        Element.prototype.focus = nativeFocus;
        const target = currentTarget;
        currentTarget = null;
        onSettle(target);
    };

    const armSettleTimer = () => {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(finish, SETTLE_DELAY);
    };

    window.addEventListener('scroll', () => {
        if (navigating) armSettleTimer();
    }, { passive: true });

    document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a) return;
        let hash;
        try {
            hash = decodeURIComponent(a.hash);
        } catch (err) {
            hash = a.hash;
        }
        if (!hash || hash === '#') return;
        const target = document.querySelector(hash);
        if (!target) return;

        navigating = true;
        currentTarget = target;
        root.style.scrollBehavior = 'auto';
        Element.prototype.focus = function (options) {
            return nativeFocus.call(this, { ...options, preventScroll: true });
        };
        armSettleTimer();
    });
};

/**
 * pg-nav スクロール制御（SP のみ）
 * 下スクロール: data-hidden を付与して非表示
 * 上スクロール: data-hidden を除去して表示
 */
const BP_SM = 640; // @include sm の閾値

const setNavScroll = () => {
    const nav = document.querySelector('.pg-nav');
    if (!nav) return;

    const mq = window.matchMedia(`(max-width: ${BP_SM}px)`);
    let lastY = window.scrollY;

    const onScroll = () => {
        if (!mq.matches) return;

        const currentY = window.scrollY;
        const isAtTop = currentY === 0;
        const isScrollingDown = currentY > lastY && currentY > nav.offsetHeight;

        nav.toggleAttribute('data-hidden', !isAtTop && isScrollingDown);
        lastY = currentY;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
};

const setNavScrollSpy = () => {
    const navItems = document.querySelectorAll('.pg-nav__item');
    if (!navItems.length) return;

    const nav = document.querySelector('.pg-nav');
    const header = document.querySelector('.l-header');

    const sections = [];
    navItems.forEach(item => {
        const a = item.querySelector('a[href^="#"]');
        if (!a) return;
        const id = a.getAttribute('href').slice(1);
        const section = document.getElementById(id);
        if (section) sections.push({ navItem: item, section });
    });

    if (!sections.length) return;

    // pg-nav に並ぶ順序と、実際にページ上でセクションが出現する順序が一致しない場合がある
    // （例: 「アクセス」より前に「周辺環境」が配置されている等）。
    // 判定は「一番下までスクロールが進んだセクション」を探す処理のため、
    // 必ず実際の DOM 出現順に並べ替えてから使う（ナビの記載順のままだと、
    // 該当セクションの手前にあるはずの項目がアクティブと誤判定され下線が付かない）
    sections.sort((a, b) => {
        const position = a.section.compareDocumentPosition(b.section);
        if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
        if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
        return 0;
    });

    const setActive = (active) => {
        navItems.forEach(item => delete item.dataset.active);
        active.navItem.dataset.active = '';

        // top セクションは URL に「#top」を残さない（素の URL のまま扱う）
        const newHash = active.section.id === 'top' ? '' : '#' + active.section.id;
        if (location.hash !== newHash) {
            history.replaceState(null, '', newHash || location.pathname + location.search);
        }
    };

    // ナビクリックによるスクロール中は、スクロール位置に基づく判定を止めておく。
    // 挙動: クリック直後は今の下線のまま維持 → スクロールが目的のセクションに到着（＝一定時間
    // 'scroll' イベントが発生しなくなった時点）で切り替える。
    // 到着時、位置(しきい値)判定に任せると非同期で読み込まれる画像等の影響で着地位置がわずかにずれ、
    // 一つ前のセクションが選ばれたまま戻らないことがあるため、到着時はクリックした遷移先を確定で反映する。
    // SmoothScroll の scrollStart/scrollStop イベントには依存しない（observeAnchorNavigation 参照）
    let isNavigating = false;
    let navigatingTarget = null;
    let settleTimer = null;
    const SETTLE_DELAY = 150;

    const update = () => {
        if (isNavigating) return;

        const headerH = header ? header.offsetHeight : 0;
        const navH = nav ? nav.offsetHeight : 0;
        const threshold = headerH + navH;

        let active = sections[0];
        for (const s of sections) {
            if (s.section.getBoundingClientRect().top <= threshold) {
                active = s;
            }
        }

        setActive(active);
    };

    const finishNavigating = () => {
        isNavigating = false;
        if (navigatingTarget) {
            setActive(navigatingTarget);
            navigatingTarget = null;
        } else {
            update();
        }
    };

    const armSettleTimer = () => {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(finishNavigating, SETTLE_DELAY);
    };

    document.addEventListener('click', (e) => {
        const a = e.target.closest('.pg-nav__item a[href^="#"]');
        if (!a) return;
        const target = sections.find(s => '#' + s.section.id === a.getAttribute('href'));
        if (!target) return;
        isNavigating = true;
        navigatingTarget = target;
        armSettleTimer();
    });

    window.addEventListener('scroll', () => {
        if (isNavigating) {
            armSettleTimer();
            return;
        }
        update();
    }, { passive: true });
    update();
};

const main = async () => {
    if (!document.querySelector('#page-estate-detail') && !document.querySelector('#page-rich')) return;
    const galleryImagesInput = document.querySelector('input[name="gallery_images"]');
    observeAnchorNavigation(() => {});

    if (!galleryImagesInput) {
        new SmoothScroll('a[href*="#"]', {
            speed: 300,
            offset: getNavScrollOffset,
            speedAsDuration: true,
            easing: 'linear',
        });
        setNavScroll();
        setNavScrollSpy();
        applyScrollMarginOffset();
        window.addEventListener('resize', applyScrollMarginOffset, { passive: true });
        // ギャラリー画像が無い物件でも「もっと見る」の判定は必要なため個別に実行する
        setPointTextAction();
        return;
    }

    const history = new History();
    const images = JSON.parse(galleryImagesInput.getAttribute('value'));
    const galleryModal = new GalleryModal({
        overlayClose: true,
        imgList: images.map((img) => {
            return {
                src: img.imagePath,
                alt: img.comment,
            }
        }),
    });
    const modal = new Modal;

    const pageId = document.querySelector('main').dataset.id;
    if (pageId.match(/^[0-9]+$/)) {
        // 閲覧履歴の記録
        history.setState(authCheck() ? 'db' : 'cookie', pageId, true)
    }

    // クリックした画像をモーダル表示
    document.querySelectorAll('.pg-gallery__main-slider img').forEach((img, index) => {
        img.addEventListener('click', (e) => {
            galleryModal.show(index)
        })
    });

    document.querySelectorAll('.pg-gallery-thumbnails__list img').forEach((img, index) => {
        img.addEventListener('click', (e) => {
            // galleryModal.show(index)
        })
    });
    // if (document.querySelector('.pg-gallery .c-buttons-default')) {
    //     document.querySelector('.pg-gallery .c-buttons-default').addEventListener('click', (e) => {
    //         e.preventDefault();
    //         galleryModal.show(0)
    //     });
    // }
    if (document.querySelectorAll('.pg-gallery__content .pg-gallery__all-view')) {
        document.querySelectorAll('.pg-gallery__content .pg-gallery__all-view').forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                galleryModal.show(0)
            });
        });
    }

    // 戸建一覧カードの「一覧」ボタン: 棟ごとの画像一覧モーダルを表示する。
    // data-images が無い(=棟固有の画像が取得できていない)場合のみ、物件全体のギャラリーにフォールバックする。
    const houseListModals = new Map();
    document.querySelectorAll('.c-cards-residence__media-action[data-type="list"]').forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            if (!button.dataset.images) {
                galleryModal.show(0);
                return;
            }
            if (!houseListModals.has(button)) {
                const images = JSON.parse(button.dataset.images);
                houseListModals.set(button, new GalleryModal({
                    overlayClose: true,
                    imgList: images.map((img) => {
                        return {
                            src: img.imagePath,
                            alt: img.comment,
                        }
                    }),
                }));
            }
            houseListModals.get(button).show(0);
        });
    });

    // 間取り/区画図ボタン: 多棟物件では棟/区画ごとの画像をスワイプ式ギャラリーで表示する。
    // data-images が無い(単独物件、または棟別画像が0件)場合は data-modal-image 側の
    // 単一画像モーダルにフォールバックする(下の汎用ハンドラでカバーされる)。
    const floorplanToolButton = document.querySelector('.pg-gallery__tool-btn--floorplan[data-images]');
    if (floorplanToolButton) {
        const floorplanImages = JSON.parse(floorplanToolButton.dataset.images);
        const floorplanModal = new GalleryModal({
            overlayClose: true,
            imgList: floorplanImages.map((img) => {
                return {
                    src: img.imagePath,
                    alt: img.comment,
                }
            }),
        });
        floorplanToolButton.addEventListener('click', (e) => {
            e.preventDefault();
            floorplanModal.show(0);
        });
    }

    document.querySelectorAll('[data-modal-image]').forEach((obj) => {
        obj.addEventListener('click', (e) => {
            const img = document.createElement('img');
            img.src = e.currentTarget.dataset.modalImage;
            const dom = document.createElement('div');
            dom.classList.add('img');
            dom.appendChild(img);
            // 区画図など、スクロールさせず画像全体を収めたいトリガーには data-modal-fit を付与する
            const modifierClass = 'modalFit' in e.currentTarget.dataset ? 'plugin-modal--fit' : null;
            modal.setModifierClass(modifierClass).setDom(dom).show();
        });
    });

    // 戻るボタン
    $('.pg-fix-content__item--back a, .pg-back a').on('click', (e) => {
        e.preventDefault();
        window.history.back();
    });

    new SmoothScroll('a[href*="#"]', {
        speed: 300,
        offset: getNavScrollOffset,
        speedAsDuration: true,
        easing: 'linear',
    });

    setOpenHouseAction();
    setOpenHouseBodyAction();
    setPointTextAction();
    setHouseListAction();
    setAmenitiesAction();
    initLandParcelSlider();
    showPropertyDetail();
    setGalleryAction();
    initGalleryThumbnailsSlider();
    setFavoriteAction(pageId);
    set360Image();
    setNavScroll();
    setNavScrollSpy();
    applyScrollMarginOffset();
    window.addEventListener('resize', applyScrollMarginOffset, { passive: true });
}

export default main;
